/* Cave Larégnère : assistant « Qu'est-ce qu'on mange ? »
   ==================================================================
   Le visiteur dit ce qu'il a. On lui dit ce qu'il peut faire.

   Pourquoi un index chargé d'un bloc plutôt qu'une recherche serveur :
   la bibliothèque compte 1 410 recettes, Liquid n'en sert que 50 par
   page, et une recherche par requête ferait attendre à chaque frappe.
   L'index pèse 95 Ko compressés, il est chargé une fois, à l'ouverture
   de la page, et tout le reste se joue en mémoire, sans réseau.

   Le classement, qui est le coeur :
     1. combien d'ingrédients MANQUENT (0, puis 1, puis 2)
     2. à égalité, combien des vôtres sont EMPLOYÉS (une recette qui
        utilise cinq de vos produits passe devant une qui en utilise un)
     3. puis la part de la recette que vous couvrez
     4. puis la saison, puis le temps de préparation

   Les basiques (sel, poivre, eau, huile, farine, beurre, sucre) sont
   supposés présents : sans cela, aucune recette n'aurait jamais zéro
   manquant et l'écran serait inutile. La case se décoche.
*/
(function () {
  'use strict';

  var R = document.querySelector('[data-clf]');
  if (!R) return;

  var URL_INDEX = R.getAttribute('data-index');
  // Le mois vient de l'horloge du VISITEUR, pas du moment où la page a été
  // fabriquée. Le 1er octobre à minuit, les primeurs et les recettes de
  // saison changent tout seuls, sans qu'on ait rien à republier.
  var CAL = (R.getAttribute('data-calendrier') || '').split('|');
  function moisCourant() { return new Date().getMonth() + 1; }   // 1 à 12
  function primeursDuMois() {
    var brut = CAL[moisCourant() - 1];
    // Repli sur le mois calculé au rendu si le calendrier manque.
    if (brut === undefined || brut === null) brut = R.getAttribute('data-primeurs') || '';
    return brut.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }
  var PRIMEURS = primeursDuMois();
  var MOIS = R.getAttribute('data-mois') || '';
  var LBL = JSON.parse(R.getAttribute('data-libelles') || '{}');

  var $ = function (s) { return R.querySelector(s); };
  var el = {
    input: $('[data-clf-input]'), sugg: $('[data-clf-sugg]'), clear: $('[data-clf-clear]'),
    rayons: $('[data-clf-rayons]'), chips: $('[data-clf-chips]'), plus: $('[data-clf-plus]'),
    sac: $('[data-clf-sac]'), vide: $('[data-clf-vide]'), raz: $('[data-clf-raz]'),
    basiques: $('[data-clf-basiques]'), saison: $('[data-clf-saison]'),
    score: $('[data-clf-score]'), onglets: $('[data-clf-onglets]'),
    grid: $('[data-clf-grid]'), rien: $('[data-clf-rien]'), charge: $('[data-clf-charge]'),
    pager: $('[data-clf-pager]'), compte: $('[data-clf-compte]'), libre: $('[data-clf-libre]'),
    tout: $('[data-clf-tout]'),
    portes: $('[data-clf-portes]'), actifs: $('[data-clf-actifs]'),
    choix: $('[data-clf-choix]'), choixTxt: $('[data-clf-choix-txt]'),
    legende: $('[data-clf-legende]')
  };

  // ---------------------------------------------------------------- outils
  function sansAccent(s) {
    return (s || '').toLowerCase().replace(/œ/g, 'oe').replace(/æ/g, 'ae').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/['’]/g, ' ');
  }
  // Un millier s'écrit « 1 410 » en français, jamais « 1410 ».
  function nb(n) {
    try { return Number(n).toLocaleString('fr-FR'); } catch (e) { return String(n); }
  }
  // Le mot tapé figure-t-il dans l'une des autres façons de nommer la chose ?
  function dansAlias(i, k) {
    var a = ALIAS[i];
    for (var j = 0; j < a.length; j++) { if (a[j].indexOf(k) >= 0) return true; }
    return false;
  }
  // « marron » doit donner la châtaigne avant la courge, dont un synonyme
  // est « potimarron » : un synonyme qui COMMENCE par le mot tapé l'emporte.
  function debutAlias(i, k) {
    var a = ALIAS[i];
    for (var j = 0; j < a.length; j++) { if (a[j].indexOf(k) === 0) return true; }
    return false;
  }
  function memeAlias(i, k) {
    var a = ALIAS[i];
    for (var j = 0; j < a.length; j++) { if (a[j] === k) return true; }
    return false;
  }
  function eches(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---------------------------------------------------------------- données
  var IDX = null;          // l'index brut
  var NOMS = [];           // id -> nom technique, sans accent et au singulier ;
                           //        c'est lui qui voyage dans l'adresse partagée
  var AFF = [];            // id -> nom montré : accentué, au pluriel
  var FAM = [];            // id -> famille
  var FREQ = [];           // id -> nombre de recettes
  var POIDS = [];          // id -> poids, d'autant plus fort que l'ingrédient est rare
  var CLE = [];            // id -> nom montré sans accent, pour la recherche
  var ALIAS = [];          // id -> les AUTRES façons de le nommer, sans accent :
                           //        le nom technique (« pomme de terre » doit
                           //        trouver « pommes de terre ») et les
                           //        synonymes (« marron », « patate »)
  var BASIQ = null;        // Set des identifiants basiques
  var POSTINGS = [];       // id -> [indices de recettes]
  var SUJETS = [];         // indice de recette -> Set des ingrédients dont elle PARLE
  var SAISON_IDS = [];     // identifiants des primeurs du mois

  var panier = new Set();
  var suggestionsSaison = [];   // ce qu'on montre tant que le garde-manger est vide
  var avecBasiques = true;
  var prioriteSaison = true;
  var rayonActif = 'courants';
  var famillesOuvertes = {};   // famille -> dépliée ou non
  var categorie = '';       // '' = l'accueil (12 suggestions de saison),
                            // '*' = TOUTE la bibliothèque, sinon une catégorie.
                            // Le menu de catégories, pour qui
                            // veut simplement parcourir sans rien saisir.
  var CATS = [];            // [nom, total dans la bibliothèque]
  var AVEC_IMAGE = 0;       // les recettes montrables : sans visuel, pas de carte
  var TAGS = [];            // les étiquettes, id = position
  var RTAGS = [];           // id de recette -> ses étiquettes
  var MENU = [];            // les axes du menu « Explorer par envie »
  var axeActif = 0;         // un seul axe ouvert, comme les rayons du haut
  var mode = 'ingr';        // 'ingr' quand l'onglet courant est un rayon
                            // d'ingrédients, 'envie' quand c'est un axe
  var filtres = new Set();  // les portes ouvertes, par id d'étiquette
  var SAISON = [];          // le vivier de saison, construit une fois
  var NB_MINI = 24;         // un écran d'accueil plein, même en mars
  var ongletActif = 0;
  // -1 : l'onglet suit les résultats. Dès que le visiteur en choisit un,
  // on respecte son choix tant qu'il reste des recettes dedans.
  var ongletChoisi = -1;
  var PAR_PAGE = 24;
  var page = 1;          // 1 et non « combien de cartes montrées » :
                         // le visiteur doit savoir où il en est

  // ---------------------------------------------------------------- chargement
  fetch(URL_INDEX, { credentials: 'omit' })
    .then(function (r) { return r.json(); })
    .then(function (d) {
      IDX = d;
      d.v.forEach(function (v, i) {
        NOMS[i] = v[0]; FAM[i] = v[1]; FREQ[i] = v[2];
        AFF[i] = v[3] || v[0];
        CLE[i] = sansAccent(AFF[i]);
        ALIAS[i] = [sansAccent(v[0])].concat(v[4] || []);
      });
      BASIQ = new Set(d.b);
      // Tous les ingrédients ne disent pas la même chose. L'œuf est dans
      // 548 recettes, la salicorne dans une : trouver une recette qui
      // emploie votre salicorne vaut infiniment mieux que d'en trouver
      // une qui emploie votre œuf. Le poids suit donc la rareté.
      POIDS = FREQ.map(function (f) { return Math.log(d.r.length / (f || 1)) + 0.2; });
      // Index inversé : pour un ingrédient, la liste des recettes qui le
      // contiennent. C'est lui qui évite de noter 1 410 recettes à chaque
      // frappe : on ne regarde que celles qui touchent le panier.
      POSTINGS = NOMS.map(function () { return []; });
      SUJETS = new Array(d.r.length);
      d.r.forEach(function (rec, ri) {
        rec[3].forEach(function (id) { POSTINGS[id].push(ri); });
        SUJETS[ri] = new Set(rec[8] || []);
        RTAGS[ri] = new Set(rec[9] || []);
      });
      TAGS = d.t || [];
      MENU = litMenu(R.getAttribute('data-menu') || '');
      // Le calendrier des primeurs est écrit au SINGULIER dans les réglages
      // (« tomate, poireau »). Depuis que les pastilles s'affichent au
      // pluriel, il faut interroger la clé technique AUSSI, sinon plus
      // aucun fruit ni légume ne porte son point vert.
      SAISON_IDS = idsDesPrimeurs();

      if (el.charge) el.charge.hidden = true;
      construitCategories();
      construitSaison();
      // La restauration D'ABORD : les pastilles doivent se dessiner en
      // sachant déjà ce qu'il y a dans le garde-manger, sinon un lien
      // partagé arrive avec un panier invisible.
      restaure();
      // ...et les suggestions APRÈS : construites avant, elles ignoraient la
      // catégorie de l'adresse. Un lien « ?c=Plat principal » montrait douze
      // recettes de saison au lieu des 584 plats.
      construitSuggestions();
      dessineRayons();
      dessineChips();
      dessineSac();
      calcule();
    })
    .catch(function () {
      if (el.charge) {
        el.charge.hidden = false;
        el.charge.textContent = LBL.erreur || 'La bibliothèque n’a pas pu être chargée.';
      }
      if (el.grid) el.grid.innerHTML = '';   // le squelette n'a plus lieu d'être
    });

  // Une page qui s'ouvre sur du vide n'invite à rien. Tant que le
  // garde-manger est vide, on montre ce que la saison propose : le
  // visiteur voit tout de suite de quoi il s'agit, et il a quelque
  // chose à regarder pendant qu'il réfléchit à ce qu'il a chez lui.
  // Le tirage change chaque jour, mais reste stable dans la journée :
  // revenir en arrière ne rebat pas les cartes sous les yeux.
  // Toutes les recettes portent une catégorie dans leur métachamp
  // `recette.categorie`. On en fait un menu : certains visiteurs ne
  // veulent rien saisir, ils veulent juste voir les desserts.
  function construitCategories() {
    var n = {};
    IDX.r.forEach(function (r) { if (r[6]) n[r[6]] = (n[r[6]] || 0) + 1; });
    AVEC_IMAGE = IDX.r.filter(function (r) { return r[2]; }).length;
    CATS = Object.keys(n).map(function (k) { return [k, n[k]]; })
                 .sort(function (a, b) { return b[1] - a[1]; });
  }

  // Combien de recettes derrière chaque porte, COMPTE TENU de ce qui est
  // déjà choisi : un compte figé enverrait dans des culs-de-sac.
  function comptePortes() {
    var c = {};
    function vu(ri) {
      var t = RTAGS[ri]; if (!t) return;
      var ok = true;
      filtres.forEach(function (f) { if (!t.has(f)) ok = false; });
      t.forEach(function (id) {
        // Une porte déjà ouverte garde son compte, sinon elle s'efface sous
        // le doigt et on ne peut plus la refermer.
        if (ok || (filtres.has(id) && compatibleSauf(t, id))) c[id] = (c[id] || 0) + 1;
      });
    }
    if (panier.size) {
      var vus = {};
      for (var z = 0; z < 4; z++) {
        resultats[z].forEach(function (x) { if (!vus[x.ri]) { vus[x.ri] = 1; vu(x.ri); } });
      }
    } else {
      for (var i = 0; i < IDX.r.length; i++) { if (IDX.r[i][2]) vu(i); }
    }
    return c;
  }
  function compatibleSauf(t, sauf) {
    var ok = true;
    filtres.forEach(function (f) { if (f !== sauf && !t.has(f)) ok = false; });
    return ok;
  }

  function nomsFiltres() {
    var noms = {}, l = [];
    MENU.forEach(function (ax) { ax.portes.forEach(function (p) { noms[p[1]] = p[0]; }); });
    filtres.forEach(function (f) { l.push(noms[f] || TAGS[f]); });
    return l.join(' \u00b7 ');
  }

  function dessineActifs() {
    if (!el.actifs) return;
    if (!filtres.size) { el.actifs.hidden = true; el.actifs.innerHTML = ''; return; }
    el.actifs.hidden = false;
    var noms = {};
    MENU.forEach(function (ax) { ax.portes.forEach(function (p) { noms[p[1]] = p[0]; }); });
    var h = '<span class="clf__actifst">' + eches(LBL.titreF || 'Vous regardez :') + '</span>';
    filtres.forEach(function (f) {
      h += '<button type="button" class="clf__actif" data-off="' + f + '" aria-label="' +
        eches((LBL.retirerF || 'Retirer') + ' ' + (noms[f] || TAGS[f])) + '">' +
        eches(noms[f] || TAGS[f]) + ' <span aria-hidden="true">\u00d7</span></button>';
    });

    h += '<button type="button" class="clf__vider" data-off="*">' +
      eches(LBL.effacerF || 'Tout effacer') + '</button>';
    el.actifs.innerHTML = h;
  }

  function surPorte(id) {
    if (filtres.has(id)) filtres['delete'](id); else filtres.add(id);
    // Ouvrir une porte, c'est quitter les douze suggestions : sinon on
    // filtrerait un échantillon au lieu de la bibliothèque.
    if (!categorie) categorie = '*';
    page = 1; ongletChoisi = -1;
    construitSuggestions(); sauve(); calcule();
  }
  if (el.portes) el.portes.addEventListener('click', function (e) {
    var b = e.target.closest('[data-t]'); if (!b) return;
    surPorte(parseInt(b.getAttribute('data-t'), 10));
  });
  if (el.actifs) el.actifs.addEventListener('click', function (e) {
    var bi = e.target.closest('[data-offi]');
    if (bi) { bascule(parseInt(bi.getAttribute('data-offi'), 10)); return; }
    var b = e.target.closest('[data-off]'); if (!b) return;
    var v = b.getAttribute('data-off');
    // « Tout effacer » ramène à l'écran d'accueil : sans la rangée
    // « De saison / Tout », c'est le seul chemin de retour.
    if (v === '*') { filtres.clear(); categorie = ''; } else filtres['delete'](parseInt(v, 10));
    page = 1; ongletChoisi = -1;
    construitSuggestions(); sauve(); calcule();
  });

  // Le menu s'écrit en clair dans l'administration : « # Titre » ouvre un
  // axe, « Libellé | etiquette » pose une porte. Une porte dont l'étiquette
  // n'existe pas dans l'index est simplement ignorée.
  function litMenu(txt) {
    var out = [], cur = null;
    txt.split('\n').forEach(function (l) {
      l = l.replace(/\r/g, '').trim();
      if (!l) return;
      if (l.charAt(0) === '#') { cur = { axe: l.slice(1).trim(), portes: [] }; out.push(cur); return; }
      if (!cur) return;
      var m = l.split('|');
      var lbl = (m[0] || '').trim(), tag = (m[1] || '').trim();
      var id = TAGS.indexOf(tag);
      if (lbl && id >= 0) cur.portes.push([lbl, id]);
    });
    return out.filter(function (a) { return a.portes.length; });
  }

  function idsDesPrimeurs() {
    return PRIMEURS.map(function (p) {
      var k = sansAccent(p);
      for (var i = 0; i < CLE.length; i++) { if (CLE[i] === k || memeAlias(i, k)) return i; }
      return -1;
    }).filter(function (i) { return i >= 0; });
  }

  function passeFiltres(ri) {
    if (!filtres.size) return true;
    var t = RTAGS[ri];
    if (!t) return false;
    var ok = true;
    filtres.forEach(function (f) { if (!t.has(f)) ok = false; });
    return ok;
  }

  // Le tirage change chaque jour mais reste stable dans la journée : on
  // retrouve la page 2 où on l'avait laissée.
  function melangeDuJour() {
    var graine = Math.floor(Date.now() / 86400000);
    return function (a, b) {
      return ((a * 9301 + graine * 49297) % 233280) - ((b * 9301 + graine * 49297) % 233280);
    };
  }

  // Le vivier de saison en entier, et non douze cartes : en automne il y a
  // 192 recettes à proposer, les cacher n'a pas de sens.
  function construitSaison() {
    var bit = bitDuMois();
    var lot = [];
    for (var i = 0; i < IDX.r.length; i++) {
      var r = IDX.r[i];
      if (r[2] && (r[7] & bit) && r[7] !== 15) lot.push(i);
    }
    // Au printemps le vivier est mince (53 fiches) : on complète pour ne
    // jamais servir un écran d'accueil à moitié vide.
    if (lot.length < NB_MINI) {
      for (var j = 0; j < IDX.r.length && lot.length < NB_MINI; j++) {
        if (IDX.r[j][2] && lot.indexOf(j) < 0) lot.push(j);
      }
    }
    lot.sort(melangeDuJour());
    SAISON = lot;
  }

  function construitSuggestions() {
    var melange = melangeDuJour();
    var bit = bitDuMois();
    if (categorie || filtres.size) {
      // « Tout », ou des portes ouvertes : on montre TOUTE la liste, les
      // recettes de saison d'abord, le reste derrière.
      var dedans = [], hors = [];
      for (var k = 0; k < IDX.r.length; k++) {
        var rk = IDX.r[k];
        if (!rk[2] || !passeFiltres(k)) continue;
        ((rk[7] & bit) && rk[7] !== 15 ? dedans : hors).push(k);
      }
      dedans.sort(melange); hors.sort(melange);
      suggestionsSaison = dedans.concat(hors);
      return;
    }
    suggestionsSaison = SAISON;
  }

  function bitDuMois() {
    var m = moisCourant();
    return (m >= 3 && m <= 5) ? 1 : (m >= 6 && m <= 8) ? 2 : (m >= 9 && m <= 11) ? 4 : 8;
  }

  // Un écran laissé ouvert la nuit du changement de mois, ou un onglet
  // réveillé en octobre : on recalcule plutôt que de servir septembre.
  var moisVu = moisCourant();
  function veilleDuMois() {
    if (moisCourant() === moisVu) return;
    moisVu = moisCourant();
    PRIMEURS = primeursDuMois();
    SAISON_IDS = idsDesPrimeurs();
    construitSaison();
    if (!categorie && !filtres.size) { page = 1; construitSuggestions(); }
    dessineRayons(); dessineChips(); calcule();
  }
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) veilleDuMois();
  });
  setInterval(veilleDuMois, 3600000);

  // ---------------------------------------------------------------- mémoire
  function sauve() {
    try {
      var fs = []; filtres.forEach(function (f) { fs.push(TAGS[f]); });
      localStorage.setItem('cl-frigo', JSON.stringify({ p: Array.from(panier), b: avecBasiques, s: prioriteSaison, c: categorie, f: fs, m: mode, o: rayonActif }));
    } catch (e) {}
    // L'adresse porte le garde-manger : une recherche se partage, se met
    // en favori, et le bouton « précédent » du navigateur ne l'efface pas.
    try {
      var noms = Array.from(panier).map(function (i) { return NOMS[i]; });
      var q = [];
      if (noms.length) q.push('j=' + encodeURIComponent(noms.join(',')));
      if (categorie) q.push('c=' + encodeURIComponent(categorie));
      if (filtres.size) {
        var fl = []; filtres.forEach(function (f) { fl.push(TAGS[f]); });
        q.push('f=' + encodeURIComponent(fl.join(',')));
      }
      if (page > 1) q.push('p=' + page);
      var u = location.pathname + (q.length ? '?' + q.join('&') : '');
      history.replaceState(null, '', u);
    } catch (e) {}
  }
  function restaure() {
    // L'adresse l'emporte sur la mémoire du navigateur : un lien partagé
    // doit montrer ce que l'expéditeur voyait, pas le frigo du lecteur.
    try {
      var par = new URLSearchParams(location.search);
      var cat = par.get('c');
      if (cat === '*') categorie = '*';
      var fq = par.get('f');
      if (fq) {
        fq.split(',').forEach(function (t) {
          var i = TAGS.indexOf(t.trim());
          if (i >= 0) { filtres.add(i); categorie = '*'; }
        });
      }
      var pg = parseInt(par.get('p') || '1', 10);
      if (pg > 1) page = pg;
      var q = par.get('j');
      if (q) {
        q.split(',').forEach(function (n) {
          var k = sansAccent(n).trim();
          for (var i = 0; i < CLE.length; i++) { if (CLE[i] === k || memeAlias(i, k)) { panier.add(i); return; } }
        });
        if (panier.size) return;
      }
      if (categorie) return;
    } catch (e) {}
    try {
      var d = JSON.parse(localStorage.getItem('cl-frigo') || 'null');
      if (!d) return;
      (d.p || []).forEach(function (i) { if (NOMS[i]) panier.add(i); });
      if (typeof d.b === 'boolean') { avecBasiques = d.b; if (el.basiques) el.basiques.checked = d.b; }
      if (typeof d.s === 'boolean') { prioriteSaison = d.s; if (el.saison) el.saison.checked = d.s; }
      if (d.m === 'envie' || d.m === 'ingr') mode = d.m;
      if (d.o) rayonActif = d.o;
      if (d.c === '*') categorie = '*';
      (d.f || []).forEach(function (t) {
        var i = TAGS.indexOf(t);
        if (i >= 0) { filtres.add(i); categorie = '*'; }
      });
    } catch (e) {}
  }

  // ---------------------------------------------------------------- rayons
  // Trois cent pastilles d'un seul bloc, c'était un mur : on ne trouvait
  // rien. Deux niveaux désormais. Le rayon dit OÙ l'on cherche (le frigo,
  // le jardin, le placard), la famille dit QUOI, et chaque famille ne
  // montre d'abord que ses quatorze ingrédients les plus employés.
  var RAYONS = [
    { cle: 'courants', lbl: LBL.courants || 'Les plus courants' },
    { cle: 'frigo', lbl: LBL.frigo || 'Mon frigo', fams: ['cremerie', 'viande', 'poisson'] },
    { cle: 'jardin', lbl: LBL.jardin || 'Mon jardin', fams: ['legume', 'fruit', 'herbe'] },
    { cle: 'placard', lbl: LBL.placard || 'Mon placard', fams: ['feculent', 'placard', 'epice', 'alcool'] }
  ];
  var NOM_FAM = {
    cremerie: LBL.famCremerie || 'Crémerie et œufs',
    viande: LBL.famViande || 'Viandes et charcuterie',
    poisson: LBL.famPoisson || 'Poissons et fruits de mer',
    legume: LBL.famLegume || 'Légumes',
    fruit: LBL.famFruit || 'Fruits',
    herbe: LBL.famHerbe || 'Herbes fraîches',
    feculent: LBL.famFeculent || 'Féculents et légumes secs',
    placard: LBL.famPlacard || 'Placard',
    epice: LBL.famEpice || 'Épices et condiments',
    alcool: LBL.famAlcool || 'Vins et alcools'
  };
  var PAR_FAMILLE = 14;
  // UNE seule rangée : les quatre rayons d'ingrédients, puis les sept axes
  // d'envie. Deux rangées se ressemblaient trop pour qu'on sache laquelle
  // servait à quoi.
  function dessineRayons() {
    var cpt = MENU.length ? comptePortes() : {};
    var vivants = MENU.map(function (ax) {
      return ax.portes.filter(function (p) { return cpt[p[1]] > 0 || filtres.has(p[1]); });
    });
    // Un axe vidé par les filtres ne doit pas rester l'onglet courant.
    if (mode === 'envie' && (!vivants[axeActif] || !vivants[axeActif].length)) {
      var s2 = -1;
      for (var v = 0; v < vivants.length; v++) { if (vivants[v].length) { s2 = v; break; } }
      if (s2 >= 0) { axeActif = s2; rayonActif = 'axe:' + s2; }
      else { mode = 'ingr'; rayonActif = 'courants'; }
    }
    var h = RAYONS.map(function (r) {
      return '<button type="button" class="clf__rayon" data-r="' + r.cle + '" aria-pressed="' +
        (mode === 'ingr' && r.cle === rayonActif) + '">' + eches(r.lbl) + '</button>';
    }).join('');
    h += '<span class="clf__sep" aria-hidden="true"></span>';
    h += MENU.map(function (ax, i) {
      if (!vivants[i].length) return '';
      var choisies = vivants[i].filter(function (p) { return filtres.has(p[1]); }).length;
      return '<button type="button" class="clf__rayon clf__rayon--envie" data-r="axe:' + i + '" aria-pressed="' +
        (mode === 'envie' && i === axeActif) + '">' + eches(ax.axe) + ' <i>' + vivants[i].length + '</i>' +
        (choisies ? '<span class="clf__pastille" aria-hidden="true">' + choisies + '</span>' : '') +
        '</button>';
    }).join('');
    el.rayons.innerHTML = h;
    // Sur tablette la rangée défile : l'onglet choisi doit rester en vue.
    var ici = el.rayons.querySelector('[aria-pressed="true"]');
    if (ici && el.rayons.scrollWidth > el.rayons.clientWidth + 4) {
      el.rayons.scrollLeft = ici.offsetLeft - (el.rayons.clientWidth - ici.offsetWidth) / 2;
    }
    // Sur téléphone, c'est le bouton replié qui dit où l'on est.
    if (el.choixTxt) {
      el.choixTxt.textContent = mode === 'ingr'
        ? (RAYONS.filter(function (x) { return x.cle === rayonActif; })[0] || RAYONS[0]).lbl
        : (MENU[axeActif] ? MENU[axeActif].axe : '');
    }
    // On ne montre que ce que l'onglet courant contient.
    el.chips.hidden = (mode !== 'ingr');
    el.portes.hidden = (mode === 'ingr');
    if (el.legende) el.legende.hidden = (mode !== 'ingr');
    if (mode === 'envie') dessinePortes(vivants[axeActif] || [], cpt);
    dessineActifs();
  }

  function dessinePortes(portes, cpt) {
    el.portes.innerHTML = '<div class="clf__lot">' + portes.map(function (p) {
      var on = filtres.has(p[1]);
      return '<button type="button" class="clf__chip" data-t="' + p[1] + '" aria-pressed="' + on + '">' +
        eches(p[0]) + ' <i>' + nb(cpt[p[1]] || 0) + '</i></button>';
    }).join('') + '</div>';
  }

  // Ouvrir et fermer la liste repliée du téléphone.
  function ouvreChoix(v) {
    if (!el.choix) return;
    el.choix.setAttribute('aria-expanded', v ? 'true' : 'false');
    el.rayons.classList.toggle('clf__rayons--ouvert', !!v);
  }
  if (el.choix) {
    el.choix.addEventListener('click', function () {
      ouvreChoix(el.choix.getAttribute('aria-expanded') !== 'true');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { ouvreChoix(false); }
    });
    document.addEventListener('click', function (e) {
      if (!R.contains(e.target)) ouvreChoix(false);
      else if (!el.choix.contains(e.target) && !el.rayons.contains(e.target)) ouvreChoix(false);
    });
  }

  el.rayons.addEventListener('click', function (e) {
    var b = e.target.closest('[data-r]'); if (!b) return;
    ouvreChoix(false);
    var v = b.getAttribute('data-r');
    if (v.indexOf('axe:') === 0) { mode = 'envie'; axeActif = parseInt(v.slice(4), 10); }
    else { mode = 'ingr'; }
    rayonActif = v;
    dessineRayons(); dessineChips(); dessineActifs(); sauve();
  });

  // ---------------------------------------------------------------- pastilles
  function enSaisonMap() {
    var m = {}; SAISON_IDS.forEach(function (i) { m[i] = 1; }); return m;
  }

  function triChips(ids, saison) {
    // De saison d'abord, puis par fréquence : ce que le marché propose
    // aujourd'hui doit tomber sous le pouce en premier.
    return ids.sort(function (a, b) {
      var sa = saison[a] ? 1 : 0, sb = saison[b] ? 1 : 0;
      if (sa !== sb) return sb - sa;
      return FREQ[b] - FREQ[a];
    });
  }

  function unChip(i, saison) {
    var s = saison[i];
    var lu = AFF[i] + (s ? ', ' + (LBL.saisonCourt || 'de saison') : '');
    return '<button type="button" class="clf__chip' + (s ? ' clf__chip--saison' : '') +
      '" data-id="' + i + '" aria-pressed="' + panier.has(i) + '" aria-label="' + eches(lu) + '">' +
      eches(AFF[i]) + (s ? '<span class="clf__pt" aria-hidden="true"></span>' : '') + '</button>';
  }

  function dessineChips() {
    // L'onglet courant peut être un axe d'envie : il n'y a alors pas de
    // pastilles d'ingrédients à dessiner, et pas de rayon à chercher.
    var r = RAYONS.filter(function (x) { return x.cle === rayonActif; })[0];
    if (!r) return;
    var saison = enSaisonMap();

    // Le rayon d'entrée : une seule poignée d'ingrédients, ceux que tout
    // le monde a. C'est un point de départ, pas un catalogue.
    if (!r.fams) {
      var ids = NOMS.map(function (_, i) { return i; }).filter(function (i) {
        return !BASIQ.has(i) && FREQ[i] >= 25;
      });
      triChips(ids, saison);
      el.chips.innerHTML = '<div class="clf__lot">' +
        ids.slice(0, 24).map(function (i) { return unChip(i, saison); }).join('') + '</div>' +
        '<p class="clf__aide">' + eches(LBL.aideRayons || 'Pour le reste, ouvrez un rayon ci-dessus, ou tapez son nom.') + '</p>';
      return;
    }

    var html = '';
    r.fams.forEach(function (f) {
      var ids = NOMS.map(function (_, i) { return i; }).filter(function (i) {
        if (FAM[i] !== f || BASIQ.has(i)) return false;
        // Une pastille pour un ingrédient présent dans une ou deux recettes
        // est du bruit : elle encombre sans rien ouvrir. Elle reste trouvable
        // par la recherche, et par le calendrier si elle est de saison.
        return FREQ[i] >= 3 || saison[i] || panier.has(i);
      });
      if (!ids.length) return;
      triChips(ids, saison);
      var ouvert = !!famillesOuvertes[f];
      // Un ingrédient déjà dans le garde-manger reste visible même s'il est
      // loin dans la liste : sinon on ne peut plus le retirer d'un clic.
      var visibles = ouvert ? ids : ids.slice(0, PAR_FAMILLE).concat(
        ids.slice(PAR_FAMILLE).filter(function (i) { return panier.has(i); }));
      var reste = ids.length - visibles.length;
      html += '<section class="clf__fam">' +
        '<h3 class="clf__famtitre">' + eches(NOM_FAM[f] || f) + ' <span>' + ids.length + '</span></h3>' +
        '<div class="clf__lot">' + visibles.map(function (i) { return unChip(i, saison); }).join('') + '</div>' +
        (reste > 0 || ouvert
          ? '<button type="button" class="clf__deplie" data-fam="' + f + '">' +
            eches(ouvert ? (LBL.replier || 'Replier')
                         : (LBL.deplier || 'Voir les {n} autres').replace('{n}', reste)) + '</button>'
          : '') +
        '</section>';
    });
    el.chips.innerHTML = html;
  }
  if (el.tout) el.tout.addEventListener('click', function () {
    categorie = '*'; page = 1; ongletChoisi = -1;
    construitSuggestions(); sauve(); calcule();
    if (el.libre) el.libre.focus ? el.libre.focus() : 0;
  });
  if (el.cats) el.cats.addEventListener('click', function (e) {
    var b = e.target.closest('[data-c]'); if (!b) return;
    var v = b.getAttribute('data-c');
    categorie = (categorie === v) ? '' : v;
    if (!categorie) filtres.clear();   // revenir à l'accueil, c'est repartir à zéro
    page = 1; ongletChoisi = -1;
    construitSuggestions(); sauve(); calcule();
  });
  el.chips.addEventListener('click', function (e) {
    var d = e.target.closest('[data-fam]');
    if (d) {
      var f = d.getAttribute('data-fam');
      famillesOuvertes[f] = !famillesOuvertes[f];
      dessineChips();
      return;
    }
    var b = e.target.closest('[data-id]'); if (!b) return;
    bascule(parseInt(b.getAttribute('data-id'), 10));
  });
  if (el.plus) el.plus.hidden = true;   // remplacé par un dépliage PAR FAMILLE

  // ---------------------------------------------------------------- panier
  function bascule(id) {
    if (panier.has(id)) panier.delete(id); else panier.add(id);
    page = 1; ongletChoisi = -1;
    dessineChips(); dessineSac(); sauve(); calcule();
  }
  function dessineSac() {
    var ids = Array.from(panier);
    el.vide.hidden = ids.length > 0;
    el.raz.hidden = ids.length === 0;
    el.sac.innerHTML = ids.map(function (i) {
      return '<li><button type="button" data-del="' + i + '" aria-label="' +
        eches((LBL.retirer || 'Retirer') + ' ' + AFF[i]) + '">' + eches(AFF[i]) + '</button></li>';
    }).join('');
  }
  el.sac.addEventListener('click', function (e) {
    var b = e.target.closest('[data-del]'); if (!b) return;
    bascule(parseInt(b.getAttribute('data-del'), 10));
  });
  el.raz.addEventListener('click', function () {
    panier.clear(); page = 1; ongletChoisi = -1; dessineChips(); dessineSac(); sauve(); calcule();
  });
  if (el.basiques) el.basiques.addEventListener('change', function () {
    avecBasiques = el.basiques.checked; sauve(); calcule();
  });
  if (el.saison) el.saison.addEventListener('change', function () {
    prioriteSaison = el.saison.checked; sauve(); calcule();
  });

  // ---------------------------------------------------------------- recherche
  var curseur = -1, propositions = [];
  el.input.addEventListener('input', function () { propose(el.input.value); });
  el.input.addEventListener('keydown', function (e) {
    if (el.sugg.hidden) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); curseur = Math.min(curseur + 1, propositions.length - 1); marque(); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); curseur = Math.max(curseur - 1, 0); marque(); }
    else if (e.key === 'Enter') { e.preventDefault(); if (propositions[curseur < 0 ? 0 : curseur] !== undefined) choisir(propositions[curseur < 0 ? 0 : curseur]); }
    else if (e.key === 'Escape') { ferme(); }
  });
  el.clear.addEventListener('click', function () { el.input.value = ''; ferme(); el.input.focus(); });
  document.addEventListener('click', function (e) { if (!el.sugg.contains(e.target) && e.target !== el.input) ferme(); });

  function ferme() { el.sugg.hidden = true; curseur = -1; propositions = []; }
  function marque() {
    Array.prototype.forEach.call(el.sugg.querySelectorAll('button'), function (b, i) {
      b.setAttribute('aria-selected', i === curseur);
      if (i === curseur) b.scrollIntoView({ block: 'nearest' });
    });
  }
  function propose(q) {
    var k = sansAccent(q).trim();
    if (k.length < 2 || !NOMS.length) { ferme(); return; }
    var debut = [], dedans = [], detour = [], fond = [];
    for (var i = 0; i < CLE.length; i++) {
      if (panier.has(i)) continue;
      var p = CLE[i].indexOf(k);
      if (p === 0) debut.push(i);
      else if (p > 0) dedans.push(i);
      else if (debutAlias(i, k)) detour.push(i);
      else if (dansAlias(i, k)) fond.push(i);
    }
    var tri = function (a, b) { return FREQ[b] - FREQ[a]; };
    debut.sort(tri); dedans.sort(tri); detour.sort(tri); fond.sort(tri);
    propositions = debut.concat(dedans, detour, fond).slice(0, 10);
    if (!propositions.length) { ferme(); return; }
    el.sugg.innerHTML = propositions.map(function (i) {
      var n = AFF[i], p = CLE[i].indexOf(k);
      // Pas de surlignage quand le mot tapé n'est pas dans le nom montré :
      // « pomme de terre » trouve « pommes de terre » sans correspondre lettre à lettre.
      var h = p < 0 ? eches(n)
        : eches(n.slice(0, p)) + '<em>' + eches(n.slice(p, p + k.length)) + '</em>' + eches(n.slice(p + k.length));
      return '<li><button type="button" data-pick="' + i + '"><span style="font-style:normal">' + h +
        '</span><span>' + FREQ[i] + ' ' +
        eches(FREQ[i] === 1 ? (LBL.recetteUne || 'recette') : (LBL.recettes || 'recettes')) + '</span></button></li>';
    }).join('');
    el.sugg.hidden = false; curseur = -1;
  }
  el.sugg.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pick]'); if (!b) return;
    choisir(parseInt(b.getAttribute('data-pick'), 10));
  });
  function choisir(id) {
    panier.add(id); el.input.value = ''; ferme(); page = 1; ongletChoisi = -1;
    dessineChips(); dessineSac(); sauve(); calcule(); el.input.focus();
  }

  // ---------------------------------------------------------------- moteur
  // Quatre paniers de résultats : rien ne manque, un, deux, puis « vous
  // en avez l'essentiel ». Ce dernier existe parce qu'une ratatouille
  // demande huit ingrédients dont cinq banals : elle ne serait jamais
  // sortie avec un plafond à deux manquants, alors que le visiteur a
  // bel et bien la courgette, l'aubergine et la tomate, c'est-à-dire
  // tout ce qui fait le plat. La couverture y est donc PONDÉRÉE par la
  // rareté : avoir l'aubergine compte, avoir l'oignon beaucoup moins.
  var resultats = [[], [], [], []];

  function calcule() {
    if (!IDX) return;
    resultats = [[], [], [], []];
    if (!panier.size) { dessineRayons(); dessineScore(0, 0); dessineOnglets(); dessineGrille(); return; }

    // Candidates : uniquement les recettes qui emploient au moins un
    // produit du panier. Sur 1 410 recettes, cela en laisse quelques
    // centaines, et le calcul reste instantané à chaque frappe.
    var vues = new Uint8Array(IDX.r.length);
    var cands = [];
    panier.forEach(function (id) {
      var p = POSTINGS[id];
      for (var j = 0; j < p.length; j++) { if (!vues[p[j]]) { vues[p[j]] = 1; cands.push(p[j]); } }
    });

    var moisBit = bitDuMois();
    // Le seuil du dernier onglet s'adapte : avec deux ingrédients en tout,
    // exiger 40 % de couverture ne laisse rien passer et l'écran paraît
    // cassé. Plus le garde-manger est fourni, plus on peut être exigeant.
    var seuilEssentiel = panier.size <= 2 ? 0.28 : (panier.size <= 4 ? 0.34 : 0.40);
    var recale = [];   // les écartés, gardés au cas où tout serait vide

    for (var c = 0; c < cands.length; c++) {
      var ri = cands[c], rec = IDX.r[ri], ing = rec[3];
      // Un ingrédient dont la recette PARLE vaut bien plus qu'un
      // ingrédient de fond : celui qui cherche « courgette » veut la
      // quiche à la courgette avant la zarzuela, qui en contient aussi
      // mais n'en fait pas son sujet.
      var suj = SUJETS[ri];
      var manque = [], utilise = 0, exiges = 0, poids = 0, total = 0;
      for (var i = 0; i < ing.length; i++) {
        var id = ing[i];
        if (avecBasiques && BASIQ.has(id)) continue;   // supposé présent
        var w = POIDS[id] * (suj && suj.has(id) ? 2.5 : 1);
        exiges++; total += w;
        if (panier.has(id)) { utilise++; poids += w; } else manque.push(id);
      }
      if (!utilise) continue;
      var partP = total ? poids / total : 0;
      var seau;
      if (manque.length <= 2) seau = manque.length;
      else if (partP >= seuilEssentiel) seau = 3;
      else { recale.push({ ri: ri, manque: manque, utilise: utilise, exiges: exiges, poids: poids, partP: partP,
                           part: exiges ? utilise / exiges : 0, saison: (rec[7] & moisBit) ? 1 : 0,
                           min: dureeEnMinutes(rec[4]) }); continue; }
      resultats[seau].push({
        ri: ri, manque: manque, utilise: utilise, exiges: exiges, poids: poids, partP: partP,
        part: exiges ? utilise / exiges : 0,
        saison: (rec[7] & moisBit) ? 1 : 0,
        min: dureeEnMinutes(rec[4])
      });
    }
    // Filet : si rien ne passe, on montre quand même les recettes qui
    // emploient le mieux ce que le visiteur a. Un écran vide alors que
    // le panier ne l'est pas donne le sentiment d'un outil en panne.
    if (!resultats[0].length && !resultats[1].length && !resultats[2].length && !resultats[3].length && recale.length) {
      recale.sort(function (a, b) { return b.partP - a.partP || b.poids - a.poids; });
      resultats[3] = recale.slice(0, 12);
    }
    // Comptage par catégorie AVANT filtrage : les pastilles doivent dire
    dessineRayons();
    if (filtres.size) {
      for (var y = 0; y < 4; y++) {
        resultats[y] = resultats[y].filter(function (x) { return passeFiltres(x.ri); });
      }
    }
    resultats.forEach(function (lot) {
      lot.sort(function (a, b) {
        if (b.partP !== a.partP && Math.abs(b.partP - a.partP) > 0.02) return b.partP - a.partP;
        if (b.poids !== a.poids) return b.poids - a.poids;
        if (b.utilise !== a.utilise) return b.utilise - a.utilise;
        if (b.part !== a.part) return b.part - a.part;
        if (prioriteSaison && b.saison !== a.saison) return b.saison - a.saison;
        return a.min - b.min;
      });
    });
    if (ongletChoisi >= 0 && resultats[ongletChoisi].length) {
      ongletActif = ongletChoisi;
    } else {
      // On ouvre sur le premier onglet qui a de quoi regarder. Ouvrir sur
      // « il me manque 1 » parce qu'il contient UNE recette, alors que
      // « j'en ai l'essentiel » en a vingt-trois, donne l'impression d'un
      // outil qui ne trouve rien.
      ongletActif = -1;
      for (var q = 0; q < 4; q++) { if (resultats[q].length >= 3) { ongletActif = q; break; } }
      if (ongletActif < 0) {
        for (var q2 = 0; q2 < 4; q2++) { if (resultats[q2].length) { ongletActif = q2; break; } }
      }
      if (ongletActif < 0) ongletActif = 0;
    }
    dessineScore(resultats[0].length, resultats[1].length);
    dessineOnglets();
    dessineGrille();
  }

  function dureeEnMinutes(t) {
    var m = /(\d+)\s*h/.exec(t || ''), n = /(\d+)\s*min/.exec(t || '');
    return (m ? parseInt(m[1], 10) * 60 : 0) + (n ? parseInt(n[1], 10) : 0) || 999;
  }

  // ---------------------------------------------------------------- écran
  function dessineScore(a, b) {
    if (!panier.size) { el.score.innerHTML = eches(LBL.invite || 'Ajoutez ce que vous avez sous la main.'); return; }
    var modele = (a === 1 ? (LBL.score1un || 'Vous pouvez faire {n} plat tout de suite.')
                          : (LBL.score1 || 'Vous pouvez faire {n} plats tout de suite.'));
    var t1 = modele.replace('{n}', '<b>' + a + '</b>');
    var t2 = b ? '<span class="clf__s2">' + (LBL.score2 || 'Et {n} de plus s’il vous manque un seul ingrédient.').replace('{n}', b) + '</span>' : '';
    el.score.innerHTML = t1 + (t2 ? '<br>' + t2 : '');
  }

  function dessineOnglets() {
    if (!panier.size) { el.onglets.innerHTML = ''; el.onglets.hidden = true; return; }
    el.onglets.hidden = false;
    var lbl = [LBL.ong0 || 'Je peux faire maintenant', LBL.ong1 || 'Il me manque 1 ingrédient',
               LBL.ong2 || 'Il me manque 2 ingrédients', LBL.ong3 || 'J’en ai l’essentiel'];
    el.onglets.innerHTML = lbl.map(function (l, i) {
      var n = resultats[i].length;
      return '<button type="button" class="clf__onglet" role="tab" id="clf-t' + i + '" data-o="' + i +
        '" aria-controls="clf-panneau" aria-selected="' + (i === ongletActif) + '" tabindex="' +
        (i === ongletActif ? '0' : '-1') + '"' + (n ? '' : ' disabled') + '>' + eches(l) + ' (' + n + ')</button>';
    }).join('');
  }
  el.onglets.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var b = Array.prototype.filter.call(el.onglets.querySelectorAll('button'), function (x) { return !x.disabled; });
    var i = b.indexOf(document.activeElement);
    if (i < 0) return;
    e.preventDefault();
    var n = b[(i + (e.key === 'ArrowRight' ? 1 : b.length - 1)) % b.length];
    n.focus(); n.click();
  });
  el.onglets.addEventListener('click', function (e) {
    var b = e.target.closest('[data-o]'); if (!b || b.disabled) return;
    ongletActif = parseInt(b.getAttribute('data-o'), 10);
    ongletChoisi = ongletActif;
    page = 1; dessineOnglets(); dessineGrille();
  });

  function dessineGrille() {
    var lot = resultats[ongletActif] || [];
    if (!panier.size) {
      el.rien.hidden = true;
      if (el.libre) {
        el.libre.hidden = false;
        el.libre.textContent = filtres.size ? nomsFiltres()
          : categorie === '*' ? (LBL.titreTout || 'Toutes nos recettes')
          : (LBL.titreSaison || 'Ce que la saison propose en ce moment');
      }
      // Le raccourci vers la bibliothèque entière, juste à côté du titre :
      // les douze suggestions sont un accueil, pas un cul-de-sac.
      if (el.tout) {
        el.tout.hidden = !!categorie;
        if (!categorie) el.tout.textContent = (LBL.toutVoir || 'Voir les {n} recettes').replace('{n}', nb(AVEC_IMAGE));
      }
      tranche(suggestionsSaison, carteSimple);
      return;
    }
    if (el.libre) el.libre.hidden = true;
    if (el.tout) el.tout.hidden = true;
    if (!lot.length) {
      el.grid.innerHTML = ''; el.rien.hidden = false;
      el.rien.textContent = LBL.aucun || 'Rien avec cette combinaison. Ajoutez un ingrédient de plus, ou retirez-en un.';
      el.pager.hidden = true; el.compte.hidden = true; return;
    }
    el.rien.hidden = true;
    tranche(lot, carte);
  }

  // ------------------------------------------------------------ pagination
  // Une page à la fois, et non un empilement : on sait combien il reste,
  // on saute loin en un clic, et le bouton « précédent » redescend.
  function tranche(liste, fabrique) {
    var q = Math.max(1, Math.ceil(liste.length / PAR_PAGE));
    if (page > q) page = q;
    if (page < 1) page = 1;
    var a = (page - 1) * PAR_PAGE;
    var b = Math.min(a + PAR_PAGE, liste.length);
    el.grid.innerHTML = liste.slice(a, b).map(fabrique).join('');
    el.compte.hidden = false;
    el.compte.textContent = q === 1
      ? (LBL.pgCompteUne || '{t} recettes').replace('{t}', nb(liste.length))
      : (LBL.pgCompte || 'Recettes {a} à {b} sur {t}')
          .replace('{a}', nb(a + 1)).replace('{b}', nb(b)).replace('{t}', nb(liste.length));
    dessinePager(q);
  }

  function boutonPage(n, texte, classe, aria) {
    return '<button type="button" class="clf__pg' + (classe ? ' ' + classe : '') +
      '" data-pg="' + n + '" aria-label="' + eches(aria) + '">' + texte + '</button>';
  }

  function dessinePager(q) {
    if (q <= 1) { el.pager.hidden = true; el.pager.innerHTML = ''; return; }
    el.pager.hidden = false;
    // Sur un téléphone, une seule page de part et d'autre : cinq pastilles
    // tiennent sur la ligne, sept n'y tiennent pas.
    var autour = window.matchMedia('(min-width:600px)').matches ? 2 : 1;
    var nums = [];
    for (var i = 1; i <= q; i++) {
      if (i === 1 || i === q || (i >= page - autour && i <= page + autour)) nums.push(i);
    }
    var h = '<div class="clf__pgs">';
    h += '<button type="button" class="clf__pg clf__pg--fl" data-pg="' + (page - 1) + '"' +
      (page === 1 ? ' disabled' : '') + '><span aria-hidden="true">\u2039</span><span class="clf__pgw">' +
      eches(LBL.pgPrec || 'Précédent') + '</span></button>';
    var prec = 0;
    nums.forEach(function (i) {
      // Le « … » n'est pas décoratif : il saute au milieu du trou, pour
      // atteindre n'importe laquelle des 25 pages en deux ou trois clics.
      if (prec && i - prec > 1) {
        var saut = Math.floor((prec + i) / 2);
        h += boutonPage(saut, '\u2026', 'clf__pg--saut',
          (LBL.pgAller || 'Aller à la page {p}').replace('{p}', saut));
      }
      h += '<button type="button" class="clf__pg' + (i === page ? ' clf__pg--ici' : '') +
        '" data-pg="' + i + '"' + (i === page ? ' aria-current="page"' : '') +
        ' aria-label="' + eches((LBL.pgAller || 'Aller à la page {p}').replace('{p}', i)) + '">' + i + '</button>';
      prec = i;
    });
    h += '<button type="button" class="clf__pg clf__pg--fl" data-pg="' + (page + 1) + '"' +
      (page === q ? ' disabled' : '') + '><span class="clf__pgw">' + eches(LBL.pgSuiv || 'Suivant') +
      '</span><span aria-hidden="true">\u203a</span></button>';
    h += '</div><p class="clf__pgp">' +
      eches((LBL.pgPage || 'Page {p} sur {q}').replace('{p}', page).replace('{q}', q)) + '</p>';
    el.pager.innerHTML = h;
  }

  el.pager.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pg]'); if (!b || b.disabled) return;
    vaPage(parseInt(b.getAttribute('data-pg'), 10));
  });
  // Les flèches du clavier font tourner les pages quand on est dans le pavé.
  el.pager.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    vaPage(page + (e.key === 'ArrowRight' ? 1 : -1));
    var b = el.pager.querySelector('.clf__pg--ici'); if (b) b.focus();
  });
  function vaPage(n) {
    if (n < 1 || n === page) return;
    page = n; dessineGrille(); sauve(); remonte();
  }
  // Changer de page sans remonter laisse le visiteur au milieu de nulle
  // part. On ne remonte que si le haut de la grille est déjà sorti par le
  // haut, et on garde de la marge pour l'en-tête collant.
  function remonte() {
    var t = el.grid.getBoundingClientRect().top;
    if (t < 0) window.scrollBy({ top: t - 90, behavior: 'smooth' });
    el.grid.focus({ preventScroll: true });
  }

  // Carte d'invitation : ni manquants ni compte, on ne sait rien encore
  // du garde-manger du visiteur.
  // Un visuel à la taille de l'écran : la même image servait 400 px de large
  // à un téléphone qui l'affiche en 162. Le navigateur choisit désormais.
  var LARGEURS = [200, 300, 400, 600, 800];
  function visuel(u) {
    if (!u) return '<div class="clf__ph"></div>';
    var b = IDX.pfx + u;
    var ss = LARGEURS.map(function (w) { return b + '&width=' + w + ' ' + w + 'w'; }).join(', ');
    return '<img src="' + b + '&width=400" srcset="' + ss + '"' +
      ' sizes="(min-width:1100px) 280px, (min-width:750px) 31vw, 46vw"' +
      ' alt="" loading="lazy" decoding="async" width="260" height="180">';
  }

  function carteSimple(ri) {
    var r = IDX.r[ri];
    var img = visuel(r[2]);
    var meta = [r[4], r[5], r[6]].filter(Boolean).map(eches).join(' · ');
    return '<li class="clf__card"><a href="/blogs/recettes-de-cuisine/' + encodeURIComponent(r[0]) + '">' + img +
      '<div class="clf__body"><p class="clf__ct">' + eches(r[1]) + '</p>' +
      (meta ? '<p class="clf__meta">' + meta + '</p>' : '') + '</div></a></li>';
  }

  function carte(x) {
    var r = IDX.r[x.ri];
    var img = visuel(r[2]);
    var meta = [r[4], r[5], r[6]].filter(Boolean).map(eches).join(' · ');
    var etat = x.manque.length === 0
      ? '<p class="clf__etat clf__etat--ok">' + eches(LBL.complet || 'Vous avez tout') + '</p>'
      : '<p class="clf__etat clf__etat--manque">' + eches(LBL.manque || 'Il manque') + ' <b>' +
        x.manque.slice(0, 3).map(function (i) { return eches(AFF[i]); }).join(', ') +
        (x.manque.length > 3 ? eches(((x.manque.length - 3 === 1 ? (LBL.etAutre || ' et 1 autre') : (LBL.etAutres || ' et {n} autres'))).replace('{n}', x.manque.length - 3)) : '') +
        '</b></p>';
    var util = '<p class="clf__utilise">' + (LBL.utilise || 'Utilise {n} de vos produits').replace('{n}', x.utilise) + '</p>';
    return '<li class="clf__card"><a href="/blogs/recettes-de-cuisine/' + encodeURIComponent(r[0]) + '">' + img +
      '<div class="clf__body"><p class="clf__ct">' + eches(r[1]) + '</p>' +
      (meta ? '<p class="clf__meta">' + meta + '</p>' : '') + util + etat + '</div></a></li>';
  }
})();
